Postlogin.LoginStats = (function () {
    const initGoogleChart = function () {
        const id = $('#login_calendar').data('id');
        const currentUserId = $('#login_calendar').data('current-user-id');
        const type = $('#login_calendar').data('type');

        // Load the Visualization API and the corechart package.
        google.charts.load('current', { packages: ['calendar'] });

        // Set a callback to run when the Google Visualization API is loaded.
        google.charts.setOnLoadCallback(drawCharts);

        let url = `/api/${type}/${id}/logins/`;

        // use my-profile routes if we're gettin this users logins
        if (+id === +currentUserId && type === 'users') {
            url = '/my-profile/logins/json';
        }

        // Callback that creates and populates a data table,
        // instantiates the pie chart, passes in the data and
        // draws it.
        function drawCharts() {
            $.ajax({
                url,
                dataType: 'json',
                method: 'GET',
                async: true,
            }).done((responseData, textStatus, jqXHR) => {
                const data = jqXHR.responseJSON;
                let totalTimeSpent = 0;
                const maxTimeSpent = Math.ceil(data.meta.max_time_spent / 60 / 60);

                const dataTable = new google.visualization.DataTable();
                dataTable.addColumn({ type: 'date', id: 'Date' });
                dataTable.addColumn({ type: 'number', id: 'Number of Events' });
                dataTable.addColumn({ type: 'string', role: 'tooltip', p: { html: true } });

                const rows = [];
                $.each(data.data, (year, months) => {
                    $.each(months, (month, days) => {
                        $.each(days, (day, value) => {
                            const date = new Date(parseInt(year), parseInt(month - 1), parseInt(day));
                            const momentDate = moment(String(String(year) + month) + day, 'YYYYMMDD').tz(moment.tz.guess());

                            let time = value.time_spent;
                            totalTimeSpent += parseInt(value.time_spent);
                            const hours = Math.floor(time / 3600);
                            time -= hours * 3600;
                            const minutes = Math.floor(time / 60);
                            const timeString = (hours > 0 ? `${hours} hour${hours === 1 ? '' : 's'}` : '')
                                + (minutes > 0 ? `${(hours > 0 ? ',<br>' : '') + minutes} minute${minutes === 1 ? '' : 's'}` : '');

                            const tooltip = `
                                <table class="calendar-tooltip">
                                    <tr><th colspan="2">${momentDate.format('LL')}</th></tr>'
                                    ${type !== 'users' ? `<tr><th><strong>Users:</strong></th><td>${value.users}</td></tr>` : ''}
                                    <tr><th><strong>Logins:</strong></th><td>${value.logins}</td></tr>
                                    <tr><th><strong>Time Spent:</strong></th><td>${timeString}</td></tr>
                                </table>
                            `;
                            const row = [date, value.time_spent / 60 / 60, tooltip];
                            rows.push(row);
                        });
                    });
                });
                dataTable.addRows(rows);

                const chart = new google.visualization.Calendar(document.getElementById('login_calendar'));
                const parentWidth = Math.round($('#login_calendar').outerWidth());
                const cellSize = (parentWidth - 118) / 53;

                const options = {
                    title: 'Hours Spent on Site',
                    tooltip: { isHtml: true },
                    width: parentWidth,
                    calendar: { cellSize },
                    colorAxis: { minValue: 0, maxValue: maxTimeSpent, colors: ['#FFFFFF', '#23527c'] },

                    noDataPattern: {
                        backgroundColor: '#fafafa',
                        color: '#f8e8e8',
                    },
                };

                let totalHours = Math.round((totalTimeSpent / 3600) * 100) / 100;
                if (totalHours > 10) {
                    totalHours = Math.round(totalHours);
                }

                chart.draw(dataTable, options);
                $('#login_calendar g text:nth-child(2)').text(
                    `${$('#login_calendar g text:nth-child(2)').text()} hr${maxTimeSpent === 1 ? '' : 's'}`,
                );
                $('#login_calendar g text:nth-child(3)').text(
                    `${totalHours.toLocaleString()} ${$('#login_calendar g text:nth-child(3)').text()}`,
                );
            });
        }

        $(window).on('resize', _.debounce(drawCharts, 250));
    };

    const init = function () {
        initGoogleChart();
    };

    return {
        init,
    };
}());
